<template>
    <div class="page_waiter__container">
        <div class="flex flex-column sm:flex-row mx-auto">
            <div class="page_waiter__loader">
                <AdaptersLoader :loading="true" type="static" />
            </div>
            <div class="flex flex-column justify-content-center gap-5 py-3">
                <div class="flex flex-column gap-2">
                  <span v-if="title" class="text-2xl">{{ title }}</span>
                  <span v-html="text" />
                </div>
                <report-waiter :rest="rest" :show-progress="true" />
            </div>
        </div>
    </div>
</template>

<script>
import ReportWaiter from "../component/ReportWaiter.vue";
import AdaptersLoader from "../component/adapters/Loader.vue";

export default {
    name: "PageWaiterComponent",
    props: {
        rest: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        text: {
            type: String,
            required: true,
        }
    },
    components: {
        ReportWaiter,
        AdaptersLoader,
    }
}
</script>
